import { createApp } from "vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./App.vue";
import { currency } from "@/JS/currency";
import messages from "./lang";
// import VueMatomo from "vue-matomo";
import { createI18n } from "vue-i18n";
import axios from "axios";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Reservation from "@/JS/Reservation.js";
import Progress from "@/JS/Progress.js";
import { isBetweenStornoDate, toPrice, scrollToElement, storeLocal, niceDate, trackEvent } from "@/JS/utilities.js";
//import VueCookies from "vue3-cookies";
import VueSmoothScroll from "vue3-smooth-scroll";


const i18n = createI18n({
  locale: "de",
  fallbackLocale: "de",
  messages,
});

// check url if en, de default
const pathArray = window.location.pathname.split("/");
var langElement = pathArray[1];

if ((langElement != 'de')&(langElement != 'en')) { 
    langElement = 'de'
}

// if en set locale
if (langElement == 'en') { 
  i18n.global.locale = 'en';
}

const app = createApp(App);

app.config.globalProperties.url = "https://www.krallerhof.com/" + langElement;
app.config.globalProperties.axios = axios;
// app.config.globalProperties.fecha = fecha;
app.config.globalProperties.reservation = Reservation;
app.config.globalProperties.progress = Progress;
app.config.globalProperties.toPrice = toPrice;
app.config.globalProperties.isBetweenStornoDate = isBetweenStornoDate;
app.config.globalProperties.scrollToElement = scrollToElement;
app.config.globalProperties.storeLocal = storeLocal;
app.config.globalProperties.niceDate = niceDate;
app.config.globalProperties.trackEvent = trackEvent;
app.config.unwrapInjectedRef = true;
app.config.globalProperties.$filters = {
  currency,
};

app.use(VueSmoothScroll);
app.use(i18n);
app.use(VueLoading);
app.use(App);

// app.use(VueMatomo, {
//   host: "https://track.krallerhof.com/",
//   siteId: 1,
//   trackerFileName: "matomo",
//   enableLinkTracking: true,
//   requireConsent: false,
//   trackInitialView: true,
//   disableCookies: false,
//   enableHeartBeatTimer: false,
//   heartBeatTimerInterval: 15,
//   debug: false,
//   userId: undefined,
//   cookieDomain: undefined,
//   domains: undefined,
//   preInitActions: [],
// });

app.mount("#app");
